import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { pageHead } from "@/lib/seo";
import { setLocale } from "@/paraglide/runtime";

export const Route = createFileRoute("/_authenticated/admin")({
  head: () =>
    pageHead({
      title: "Admin | Mark Egly Golf",
      description: "Admin dashboard for Mark Egly Golf.",
      path: "/admin",
      noindex: true,
    }),
  beforeLoad: () => {
    void setLocale("en", { reload: false });
  },
  component: AdminRouteLayout,
});

function AdminRouteLayout() {
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
